import { render } from "./LogDetail.vue?vue&type=template&id=c1910174&scoped=true"
import script from "./LogDetail.vue?vue&type=script&lang=js"
export * from "./LogDetail.vue?vue&type=script&lang=js"

import "./LogDetail.vue?vue&type=style&index=0&id=c1910174&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1910174"]])

export default __exports__